import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from "react-redux";
import { Businesses } from '../../config/Helper';
import * as apiConstant from '../../api/apiConstant';
import SingleSlider from '../../components/SingleSlider';
import ScrollToTop from '../home/ScrollToTop/ScrollToTop';

class AgencyItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
        this.business = Businesses.indexOf('agency');

    }

    componentWillMount() {
    }

    componentDidMount() {
        if (this.props.medias.length > 0) {
            ReactDOM.render(<SingleSlider media={this.props.medias} business={this.business} id={this.props.agency.id} title={this.props.agency.title} />, document.getElementById('single_slider_container'));
            // setTimeout(() => {
            //     window.initSingleSlider();
            // }, 100);             
        }

    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(newProps) {
        ReactDOM.render(<SingleSlider media={newProps.medias} business={this.business} id={newProps.agency.id} title={this.props.agency.title} />, document.getElementById('single_slider_container'));

    }
    componentDidUpdate() {

    }

    render() {
        return (
            <div>
                <section className="ftco-services-2 ftco-no-pt" id="agencyItemSec">
                    {/*<hr className="solid tall"/>*/}
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="portfolio-title">
                                    <div className="row mt-5 mb-4">
                                        {this.props.agency.mark_path !== '' &&
                                            <div>
                                                <img src={apiConstant.agencyMarkURL(this.props.agency.mark_path)} className="alignleft fadeInLeftBig animated" alt="agency-mark-url" title="" data-animate="fadeInLeftBig" style={{ height: 80, marginTop: -6 }} />
                                            </div>
                                        }
                                        <div className=" caption middle-title ml-2" id="agency_title">
                                            <h2 className="mb-none alignleft fadeInRightBig animated" data-animate="fadeInRightBig" ><span >{this.props.agency.title}</span></h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<hr className="solid tall"/>*/}
                    <div className="container">
                        <div className="row d-flex justify-content-center">
                            <div className={this.props.medias.length > 0 ? 'col-lg-6 col-md-12 header-left' : 'col-lg-0 col-md-0'}>
                                <div id="single_slider_container">

                                </div>
                            </div>
                            <div className={this.props.medias.length > 0 ? `subheading col-lg-6 col-md-12 pl-4` : `subheading col-lg-12 col-md-12 pl-4`} style={{ zIndex: 0, }}>
                                <p className="pt-20" dangerouslySetInnerHTML={{ __html: this.props.agency.description }}>
                                </p>
                            </div>

                        </div>
                        <hr className="solid tall" />
                    </div>
                    <ScrollToTop />
                </section>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default connect(mapStateToProps)(AgencyItem);